import i18b from '@/configs/i18n'
import { LOCAL_STORAGE_KEY_LANG } from '@/constants/localStorageKeys'

export const handleChangeLanguage = (lang: string) => {
  i18b.changeLanguage(lang)
  window.localStorage.setItem(LOCAL_STORAGE_KEY_LANG, lang)
  window.location.reload()
}
